var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "header-left left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("galleryHost.output")) + ":")]), _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scroll,
      expression: "scroll"
    }],
    staticClass: "selectBox",
    attrs: {
      "visible-arrow": false,
      "placeholder": _vm.$t('galleryHost.outputPlaceholder'),
      "no-data-text": "No Data",
      "no-match-text": "No Data",
      "popper-class": "pullStreamDrop",
      "remote-method": _vm.filterReceiverList,
      "filterable": "",
      "remote": ""
    },
    on: {
      "visible-change": _vm.getReceiverList
    },
    model: {
      value: _vm.receiverId,
      callback: function ($$v) {
        _vm.receiverId = $$v;
      },
      expression: "receiverId"
    }
  }, _vm._l(_vm.receiverList, function (item) {
    return _c('el-option', {
      key: item.peerId,
      attrs: {
        "label": item.name,
        "value": item.peerId
      }
    });
  }), 1), _c('el-divider', {
    staticClass: "nameDivider",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-button', {
    staticClass: "outputBtn",
    class: {
      grays: _vm.sendBtnColor == 'gray',
      'green-gradient': _vm.sendBtnColor == 'green',
      'red-gradient': _vm.sendBtnColor == 'red'
    },
    attrs: {
      "disabled": !_vm.receiverId
    },
    on: {
      "click": _vm.setPartyOutput
    }
  }, [_vm._v(" " + _vm._s(_vm.sendBtnColor == 'red' ? _vm.$t('galleryHost.stop') : _vm.$t('galleryHost.send'))), _vm.loadingBtn ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]), _vm.nameInfo.show ? _c('new-dialog', {
    attrs: {
      "title": _vm.$t('galleryHost.nameOperation'),
      "info": _vm.nameInfo,
      "confirmEvent": _vm.setNameOperation
    }
  }, [_c('div', {
    staticClass: "nameBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.nameOperationCon')))]), _c('el-switch', {
    staticClass: "right",
    attrs: {
      "active-color": "#F6445A",
      "inactive-color": "#C5C5C5"
    },
    model: {
      value: _vm.nameCheck,
      callback: function ($$v) {
        _vm.nameCheck = $$v;
      },
      expression: "nameCheck"
    }
  })], 1)]) : _vm._e(), _vm.tipsInfo.show ? _c('TipsDailog', {
    attrs: {
      "info": _vm.tipsInfo,
      "showClose": false
    },
    on: {
      "save": _vm.startPullStream,
      "cancel": function ($event) {
        _vm.loadingBtn = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };